/* eslint-disable max-len */
( function () {
  'use strict';

  const MEGA_MENU_ITEM_SELECTOR = '.mega-menu-item.mega-menu-item-has-children.mega-menu-megamenu';
  const COLUMNS_CONTAINER_SELECTOR = '.mega-menu-row > .mega-sub-menu';
  const COLUMN_SELECTOR = ':scope > .mega-menu-column';
  const SEPARATOR_CLASS = 'js-mega-menu-column-separator';
  const CONTAINER_CLASS = 'js-mega-menu-has-separators';
  const MIN_DESKTOP_WIDTH = 1200; // trigger only on >1199px

  function removeExistingSeparators( container ) {
    container.querySelectorAll( `.${SEPARATOR_CLASS}` ).forEach( ( node ) => node.remove() );
    container.classList.remove( CONTAINER_CLASS );
  }

  function isElementVisible( element ) {
    return !!( element && element.offsetParent !== null );
  }

  function createSeparator( container, xPosition, beforeColumn ) {
    const separator = document.createElement( 'span' );
    separator.className = SEPARATOR_CLASS;
    separator.setAttribute( 'aria-hidden', 'true' );
    separator.style.setProperty( '--separator-left', `${Math.round( xPosition )}px` );
    if ( beforeColumn && beforeColumn.parentNode === container ) {
      container.insertBefore( separator, beforeColumn );
      return;
    }
    container.appendChild( separator );
  }

  function applyColumnSeparators( container ) {
    if ( !isElementVisible( container ) ) {
      removeExistingSeparators( container );
      return;
    }

    const columns = Array.from( container.querySelectorAll( COLUMN_SELECTOR ) ).filter( isElementVisible );
    if ( columns.length < 2 ) {
      removeExistingSeparators( container );
      return;
    }

    removeExistingSeparators( container );
    container.classList.add( CONTAINER_CLASS );

    const containerRect = container.getBoundingClientRect();

    for ( let i = 1; i < columns.length; i += 1 ) {
      const currentRect = columns[ i ].getBoundingClientRect();
      const x = currentRect.left - containerRect.left;
      createSeparator( container, x, columns[ i ] );
    }
  }

  function clearAllDropdownSeparators() {
    document.querySelectorAll( COLUMNS_CONTAINER_SELECTOR ).forEach( ( container ) => {
      removeExistingSeparators( container );
    } );
  }

  function updateAllDropdownSeparators() {
    if ( window.innerWidth < MIN_DESKTOP_WIDTH ) {
      clearAllDropdownSeparators();
      return;
    }

    const megaMenuItems = document.querySelectorAll( MEGA_MENU_ITEM_SELECTOR );

    megaMenuItems.forEach( ( item ) => {
      item.querySelectorAll( COLUMNS_CONTAINER_SELECTOR ).forEach( ( container ) => {
        applyColumnSeparators( container );
      } );
    } );
  }

  function scheduleSeparatorUpdate() {
    requestAnimationFrame( () => {
      updateAllDropdownSeparators();
    } );
  }

  function bindMegaMenuEvents() {
    const megaMenuItems = document.querySelectorAll( MEGA_MENU_ITEM_SELECTOR );

    megaMenuItems.forEach( ( item ) => {
      item.addEventListener( 'mouseenter', scheduleSeparatorUpdate );
      item.addEventListener( 'focusin', scheduleSeparatorUpdate );
    } );
  }

  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', () => {
      bindMegaMenuEvents();
      scheduleSeparatorUpdate();
    } );
  } else {
    bindMegaMenuEvents();
    scheduleSeparatorUpdate();
  }

  window.addEventListener( 'resize', scheduleSeparatorUpdate );
} )();
